/**
 * Load CSS variables into the global CSS object
 * So that we can access them in the js.
 */
import { CssConfig } from '@js/types'


const DEFAULT_CSS_CONFIG: CssConfig = {
  // overriden by css 
  boxBorderSize: 1,
  boxWidth: 125,
  boxHeightMin: 25,
  
  thumbnailImageMarginTop: 15,
  thumbnailImageMarginBottom: 10,
  
  zIndexThumbnailMin: 20,
  
  fontSizeP1: 0.75,
  fontSizeP2: 1.5,
  fontSizeP3: 2,
  fontSizeP4: 3,
  fontSizeP5: 4,

  chatboxHeight: 300,
  chatboxWidth: 400,

  aproposWidth: 400,
  aproposWidthMin: 50,

  actuHeight: 120,
  actuWidth: 300,
  actuWidthMin: 50,

  captchaWidth:    200,
  captchaHeight:   200,
  captchaWidthMin: 200,

}

export class CSSManager {
  private css_raw_vars: CSSModuleClasses
  css_vars: CssConfig

  constructor(css_raw_vars: CSSModuleClasses) {
    this.css_vars = { ...DEFAULT_CSS_CONFIG }
    this.css_raw_vars = css_raw_vars
  }

  loadVariables(): CssConfig {
    for (const key in DEFAULT_CSS_CONFIG) {
      const typedKey = key as keyof CssConfig
      const rawValue = this.css_raw_vars[typedKey]
      const parsed = this.parseValue(rawValue)
      this.css_vars[typedKey] = parsed ?? DEFAULT_CSS_CONFIG[typedKey]
    }

    console.debug('css variables loaded:', this.css_vars)
    return this.css_vars
  }
  /**
   * Parse CSS value and remove unit
   */
  private parseValue(value: string): number {
    // If value only contains numbers, convert to int
    if (value.match(/^\d+$/)) {
      return parseInt(value)
    }

    // If value contains a unit, remove unit and convert to float
    const cssUnits = ['rem', 'em', 'vh', 'vw', 'vmin', 'vmax', 'ex', '%', 'px', 'cm', 'mm', 'in', 'pt', 'pc', 'ch']
    for (const unit of cssUnits) {
      if (value.indexOf(unit) >= 0) {
        return parseFloat(value.replace(unit, ''))
      }
    }
    return 0
  }
}